import { MessageTypeEnum } from 'enum'
import Api from './Api'

class Message extends Api {
  readonly urls = {
    all: '/Message/AllMessage',
    sendMessageToUser: '/Message/SendMessageToUser',
    sendMessageToPharmacy: '/Message/SendMessageToPharmacy',
    read: '/Message/Read/',
    currentUserMessages: '/Message/CurrentUserMessages',
    readMulti: '/Message/ReadMulti',
  }

  getAllMessages = async (): Promise<any> => {
    const result = await this.postData(this.urls.all)
    return result.data
  }

  createNewMessage = async (data: any): Promise<any> => {
    const result = await this.postJsonData(this.urls.sendMessageToUser, data)
    return result.data
  }

  sendMessageToPharmacy = async (data: any): Promise<any> => {
    const result = await this.postJsonData(this.urls.sendMessageToPharmacy, data)
    return result.data
  }

  readMessage = async (messageId: number | string): Promise<any> => {
    const result = await this.postData(`${this.urls.read}${messageId}`)
    return result.data
  }

  getUserMessages = async (
    justUnreadMessages = false,
    skip = 0,
    top = 10,
    type?: MessageTypeEnum,
  ): Promise<any> => {
    let queryString = ''

    if (justUnreadMessages) {
      queryString += '&$filter=readDate eq null'
    }
    if (type !== undefined) {
      queryString += `${
        queryString.includes('filter')
          ? `&type eq ${type}`
          : `&$filter=type eq ${type}`
      }`
    }
    const result = await this.postData(
      `${this.urls.currentUserMessages}?$skip=${skip}&$top=${top}` +
      `&$orderby=id desc${queryString}`,
    )
    return result?.data
  }

  readMultiMessage = async (data: Array<number>): Promise<any> => {
    const result = await this.postJsonData(this.urls.readMulti, data)
    return result.data
  }
}

export default Message
